import { CIMSTabs } from 'components/CIMSTabs'
import { Permission } from 'shared'
import MixDesigns from './components/MixDesigns'
import Targets from './components/Targets'

const Asphalt: React.VFC = () => {
  const tabs = { MixDesigns: 'Mix Designs', Targets: 'Targets' } as const
  return (
    <CIMSTabs
      tabs={[
        {
          key: tabs.MixDesigns,
          component: <MixDesigns />,
          label: tabs.MixDesigns,
          permission: Permission.ViewAsphaltMixDesign,
        },
        {
          key: tabs.Targets,
          component: <Targets />,
          label: tabs.Targets,
          permission: Permission.ViewLIMSAsphaltMixDesignTarget,
        },
      ]}
      initialTab={tabs.MixDesigns}
    />
  )
}

export default Asphalt
